import * as React from "react";
import { Controller } from "react-hook-form";
import { helperTextPlaceHolder, InputProps } from "./form";
import {
    Checkbox as MuiCheckbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
} from "@mui/material";
import { useTranslation } from "../../utils/i18n/lang";
import { messages } from "../../utils/i18n/i18n";

interface Props extends InputProps {
    label: React.ReactNode;
    fullWidth?: boolean;
}

export const RequiredCheckbox = React.forwardRef((p: Props, _ref) => {
    const defaultValue = false;
    const t = useTranslation(msg);

    return (
        <Controller
            name={p.name}
            control={p.control}
            defaultValue={defaultValue}
            render={({ field }) => {
                const helperText =
                    p.error &&
                    p.required &&
                    (p.helperText == null ||
                        p.helperText === helperTextPlaceHolder)
                        ? t.required
                        : p.helperText;

                return (
                    <FormControl
                        required={p.required}
                        fullWidth={p.fullWidth}
                        error={p.error}
                    >
                        <FormControlLabel
                            control={
                                <MuiCheckbox
                                    checked={field.value}
                                    inputRef={field.ref}
                                    {...field}
                                />
                            }
                            label={
                                <>
                                    {p.label}
                                    {p.required ? "*" : ""}
                                </>
                            }
                        />
                        <FormHelperText error={p.error}>
                            {helperText}
                        </FormHelperText>
                    </FormControl>
                );
            }}
        />
    );
});

const msg = messages(
    { required: "field is required to check" },
    {
        cs: {
            required: "pole je povinné zaškrtnout",
        },
    }
);
